import React from 'react';
import { ManagedModal, ModalContentArea } from '@riac/design-system';
import { SuggestedContainer } from 'src/components/AddressValidation/SuggestedAddressModal.style';
import { BoxButton } from '@riac/design-system';

interface ISuggestedAddressModal {
  original: {
    name?: string,
    address1: string,
    address2?: string,
    city: string,
    state: string|React.Key,
    zipCode: string,
  };
  suggested: {
    sugName?: string,
    sugAddr2?: string,
    sugAddr1: string,
    sugCity: string,
    sugState: string,
    sugZip4: string,
    sugZip5: string,
  };
  selectOriginal(): void;
  selectSuggested(): void;
  cancel(): void;
  children?: React.ReactNode;
  open?: boolean;
}

export const SuggestedAddressModal = ({
  original,
  suggested,
  selectOriginal,
  selectSuggested,
  cancel,
  children,
  open,
}: ISuggestedAddressModal) => {
  return (
    <ManagedModal
      isOpen={open ?? true}
      isDismissable
      showCloseButton
      onClose={(e) => cancel()}
    >
      <ModalContentArea>
        {children}
        <SuggestedContainer>
          <div>
            <h5>You entered:</h5>
            {original.name && <p>{original.name}</p>}
            <p>{original.address1}</p>
            {original.address2 && <p>{original.address2}</p>}
            <p>
              {original.city}, {original.state} {original.zipCode}
            </p>
            <BoxButton onPress={selectOriginal}>Use Original</BoxButton>
          </div>
          <div>
            <h5>Suggested Address:</h5>
            {suggested.sugName && <p>{suggested.sugName}</p>}
            <p>{suggested.sugAddr1}</p>
            {suggested.sugAddr2 && <p>{suggested.sugAddr2}</p>}
            <p>
              {suggested.sugCity}, {suggested.sugState} {suggested.sugZip5}-{suggested.sugZip4}
            </p>
            <BoxButton onPress={selectSuggested}>Use Suggested</BoxButton>
          </div>
        </SuggestedContainer>
      </ModalContentArea>
    </ManagedModal>
  );
};
